interface IGlobalConfig {
    apiUrl: string;
    applicationInsightsKey: string;
    appName: string;
    appUrl: string;
    baseUrl: string;
    buildDate: Date;
    debug: boolean;
    pinterestDomainId: string;
    version: string;
    ui: {
        breakpoints: {
            xs: number;
            sm: number;
            md: number;
            lg: number;
            xl: number;
        };
        facetsHideAfterIndex: number;
        fileDropToken: string;
        paginationMarginPagesDisplayed: number;
        paginationPageRangeDisplayed: number;
    };
}

declare const __GLOBAL_CONFIG__: IGlobalConfig;

const _GLOBAL_CONFIG = __GLOBAL_CONFIG__;

(() => {
    InitializeUi();
    InitializeProApiUrl();
    InitializeAppUrl();
})();

function InitializeProApiUrl() {
    const { hostname } = window.location;
    if (hostname.indexOf("-staging") >= 0) {
        _GLOBAL_CONFIG.apiUrl = _GLOBAL_CONFIG.apiUrl.replace(
            /api.relode.com/gi,
            "api-staging.relode.com"
        );
        console.log("using the staging pro api url");
    }

    if (!_GLOBAL_CONFIG.apiUrl) {
        console.error("no pro or general api url specified in config");
        return;
    }

    if (_GLOBAL_CONFIG.apiUrl.endsWith("/")) {
        _GLOBAL_CONFIG.apiUrl = _GLOBAL_CONFIG.apiUrl.substr(
            0,
            _GLOBAL_CONFIG.apiUrl.length - 1
        );
    }
}

function InitializeAppUrl() {
    const { protocol, hostname, port } = window.location;

    _GLOBAL_CONFIG.appUrl = `${protocol}//${hostname}${
        !!port ? ":" + port : ""
    }${_GLOBAL_CONFIG.baseUrl}`;
}

function InitializeUi() {
    _GLOBAL_CONFIG.ui = {
        breakpoints: {
            xs: 480,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1440,
        },
        facetsHideAfterIndex: 5,
        fileDropToken:
            "aTj5-Oid0SG7pYtOjAWfITRaXWstd05Pm1pAUVYRXXcFuHmNKq-j_jNFMWAN78-7ahqhaOFWkR9zeLGoOGWxU5O3LfQuV-tcXiOtltOg0SfhUetobl9QsIQFKyU_iJnw0_7iCH9hjx7y3xBkTDJRPB95mlmQSY23f8WnvyiHnXgCKZDwduEVzHH_4fUHt9X1qIPT_bkD6nbWN2q-0ItLdWO_53FLfhPDfAJqSzkRseiu-NjTe1VT9VzTkbLDXD4bNThuB-wS9zDwaOuzuv7R6zg_HAspxxGMbtACaCZQOxXwZ39JjOgQSXtVluxhZwcjCYwGmQZ9C1YVckWYC8uB3aO7NpOHMNJsNlrETCFq4qh4qX0whQhMjgGY8GbVW32nTjkX5KRaI3uxQU6gPg1s3PxLVbVIZXkN8ZaZF_2-5qSkRSRHer1NV5CIlREx_5ebdr20mX0ISdIsBza8sMyEsbnuL23_HxMpACVmSqWd9t1cpfYqwWhVuFbGKNn0BLDhT03FdHiMoz3wrrtZHXl9iwDQk2NBb72iEavxEXrLGyivBTjTpoW1016C8sCLPQrGgp9e0jobBH5JeqAV2dp6oG51wb8FvbgkvKhXDQBjo_O9xrRxSCxKH3kCoG1sIA7UgvPKQw",
        paginationMarginPagesDisplayed: 1,
        paginationPageRangeDisplayed: 2,
    };
}

export { _GLOBAL_CONFIG as GlobalConfig };
